import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useBranding() {
  const { data } = useQuery({
    queryKey: ["branding"],
    queryFn: async () => (await api.get("/settings/branding")).data,
    staleTime: 5 * 60 * 1000,
  });
  return {
    appName: data?.app_name || "Equity CRM",
    companyName: data?.company_name || "Adari.interior",
  };
}
